import { motion } from "framer-motion";
import { useContent } from "../../i18n/useContent";
import { Icon } from "../ui/Icons";
import { Button } from "../ui/Button";
import { RevealGroup, revealItemVariants } from "../ui/Reveal";
import "./Services.css";

function Services() {
  const { services } = useContent();

  return (
    <section id="servicios" className="section services">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow">{services.eyebrow}</span>
          <h2 className="section-title">{services.title}</h2>
        </div>

        <RevealGroup className="services-grid" stagger={0.08}>
          {services.items.map((item, index) => (
            <motion.article
              className={["services-card", index % 2 !== 0 && "services-card--amber"]
                .filter(Boolean)
                .join(" ")}
              variants={revealItemVariants}
              key={item.id}
            >
              <span className="services-icon">
                <Icon name={item.icon} size={28} />
              </span>
              <h3 className="services-card-title">{item.title}</h3>
              <p className="services-card-text">{item.text}</p>
            </motion.article>
          ))}
        </RevealGroup>

        <div className="services-cta">
          <Button href="#contacto" variant="outline" arrow>
            {services.cta}
          </Button>
        </div>
      </div>
    </section>
  );
}

export default Services;
